module.exports = {
    APP_URL: 'https://viaplaysportbooking.com',
    API_URL: 'https://api.viaplaysportbooking.com',
    SOCKET_URL: 'https://lecho.viaplaysportbooking.com',
    SOCKET_APP_ID: 'MTG_BOOKING',
    SOCKET_CLIENT_KEY: 'fa77cf3850f77861633c4386fc43b712',
    SOCKET_TEST_ID: 'By WingmaN v.1.00',
}
